import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Olli Powroznik
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : utility functions
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import log from 'uix/logging';
import clsx from 'clsx';
// ---Local imports
import S from './tiles.scss';
export const Tiles = ({ children, gap, columns, type, position })=>{
    let gapS = gap ? {
        '--wiki-tiles-gap': `${gap}`
    } : null;
    let columnS = columns ? {
        '--wiki-tiles-columns': columns
    } : null;
    return /*#__PURE__*/ _jsx("div", {
        style: {
            ...columnS,
            ...gapS
        },
        className: clsx(S.tiles, S[`c${columns}`], S[type], S[position]),
        children: children
    });
};
export const Tile = ({ caption, img })=>{
    let imgS = img ? {
        '--wiki-tile-bgImg': `url(${img})`
    } : null;
    return /*#__PURE__*/ _jsxs("div", {
        style: imgS,
        className: S.tile,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: S.caption,
                children: caption
            }),
            /*#__PURE__*/ _jsx("div", {
                className: S.bg
            })
        ]
    });
};
